import React from 'react';
import injectSheet from 'react-jss';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import NewBucketModal from './NewBucketModal';

class AddOrganizationBucket extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isDialogOpen: false };
    }

    onDialogOpen = () => {
        this.setState({ isDialogOpen: true });
    };

    onDialogClose = () => {
        this.setState({ isDialogOpen: false });
    };

    render() {
        const { classes } = this.props;
        const { isDialogOpen } = this.state;

        return (
            <React.Fragment>
                <Tooltip title="Create project">
                    <Button
                        className={classes.createProjectButton}
                        onClick={this.onDialogOpen}
                        color="primary"
                        variant="contained"
                    >
                        <i className="material-icons">add</i>
                    </Button>
                </Tooltip>
                <NewBucketModal
                    show={isDialogOpen}
                    onClose={this.onDialogClose}
                />
            </React.Fragment>
        );
    }
}

const style = ({ spacing }) => ({
    content: {
        display: 'flex',
        flexDirection: 'column',
    },
    icon: {
        composes: ['material-icons'],
        marginRight: spacing.unit,
    },
    createProjectButton: {
        borderRadius: '50%',
        minWidth: '60px', // Overrides Material-UI min-width: 64px
        height: '60px',
        boxShadow: '0 0 6px 0 rgba(0,0,0,0.12), 0 6px 6px 0 rgba(0,0,0,0.24)',
    },
});

export default injectSheet(style)(AddOrganizationBucket);



// WEBPACK FOOTER //
// ./src/containers/organizationBuckets/AddOrganizationBucket.js